import script from "./ArtworkReplaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtworkReplaceModal.vue?vue&type=script&setup=true&lang=js"

import "./ArtworkReplaceModal.vue?vue&type=style&index=0&id=ee218c7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee218c7c"]])

export default __exports__